import PropTypes from 'prop-types'
import { Navigate } from 'react-router-dom'
import { Access } from 'types'

import KeycloakService from 'services/KeycloakService'

const RequireRole = ({
  roles,
  children,
}: {
  roles: Access
  children: JSX.Element
}) =>
  KeycloakService.hasRole(roles) ? (
    children
  ) : (
    <Navigate to="/not-allowed" replace={true} />
  )

RequireRole.propTypes = {
  roles: PropTypes.arrayOf(PropTypes.string).isRequired,
}

export default RequireRole
